import React, {useState} from 'react';
import {Trans} from 'react-i18next';
import InfoDialog from '../../../../components/dialogs/InfoDialog';
import classnames from 'classnames';
import ConfirmDialog from '../../../../components/dialogs/ConfirmDialog';
import _get from 'lodash/get';
import PreviewQrCode from './PreviewQrCode';

export default function PreviewBtns({
  dirty,
  handlePreview,
  actionBtns,
  isSubmitting,
}) {
  const [showPreviewCode, setShowPreviewCode] = useState(false);
  const enablePreview = _get(actionBtns, 'enable_preview', false);
  const enableGeneratePreview = _get(
    actionBtns,
    'enable_generate_preview',
    false
  );
  const status = _get(actionBtns, 'status');

  if (dirty) {
    return (
      <>
        <InfoDialog
          trigger={'click'}
          placement={'bottom'}
          description={
            <Trans i18nKey="p.s.uiconfiguration.publish.online.desc">
              You need save all unsaved changes, please save your page first.
            </Trans>
          }
        >
          <div
            className="mr-2"
            style={{
              display: 'inline-block',
              cursor: 'not-allowed',
            }}
          >
            <button
              disabled
              style={{pointerEvents: 'none'}}
              className="btn btn-outline-primary"
            >
              <Trans i18nKey="p.s.uiconfiguration.app.preview.qrcode">
                App Preview QR Code
              </Trans>
            </button>
          </div>
        </InfoDialog>
        <InfoDialog
          trigger={'click'}
          placement={'bottom'}
          description={
            <Trans i18nKey="p.s.uiconfiguration.publish.online.desc">
              You need save all unsaved changes, please save your page first.
            </Trans>
          }
        >
          <div
            className="mr-2"
            style={{
              display: 'inline-block',
              cursor: 'not-allowed',
            }}
          >
            <button
              disabled
              style={{pointerEvents: 'none'}}
              className="btn btn-success"
            >
              <Trans i18nKey="p.s.uiconfiguration.generate.app.preview">
                Generate App Preview
              </Trans>
            </button>
          </div>
        </InfoDialog>
      </>
    );
  }

  return (
    <>
      <button
        type="button"
        disabled={!enablePreview || isSubmitting}
        className="btn btn-outline-primary mr-2"
        onClick={() => setShowPreviewCode(true)}
      >
        <Trans i18nKey="p.s.uiconfiguration.app.preview.qrcode">
          App Preview QR Code
        </Trans>
      </button>
      <ConfirmDialog
        confirmCallback={handlePreview}
        placement={'bottom'}
        title={
          <>
            <Trans i18nKey="p.s.uiconfiguration.preview.online.title">
              All UI configurations in the four tabs will be processed for
              preview in the app. This may take up to 30 minutes.
            </Trans>
            <br />
            <br />
            <Trans i18nKey="c.dialog.sure.continue">
              Are you sure to continue?
            </Trans>
          </>
        }
      >
        <button
          type="button"
          disabled={!enableGeneratePreview || isSubmitting}
          className={classnames({
            btn: true,
            'btn-success': true,
            'kt-spinner': true,
            'kt-spinner-v2': true,
            'kt-spinner--center': true,
            'kt-spinner--sm': true,
            'kt-spinner--warning': status === 'Previewing',
            'mr-2': true,
          })}
        >
          <Trans i18nKey="p.s.uiconfiguration.generate.app.preview">
            Generate App Preview
          </Trans>
        </button>
      </ConfirmDialog>
      <PreviewQrCode
        actionBtns={actionBtns}
        show={showPreviewCode}
        setShow={setShowPreviewCode}
      />
    </>
  );
}
